module.exports = __webpack_public_path__ + "img/ic_points_op.20dabee7.svg";